// extracted by mini-css-extract-plugin
module.exports = {"container":"propertyCardLoader_container__3YR3P","content":"propertyCardLoader_content__2czB7","img":"propertyCardLoader_img__1DXGQ","shine":"propertyCardLoader_shine__1N5ld"};
    if(module.hot) {
      // 1745223419286
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  